import { render } from "./AudioDiv.vue?vue&type=template&id=16f0c45e&scoped=true&ts=true"
import script from "./AudioDiv.vue?vue&type=script&lang=ts"
export * from "./AudioDiv.vue?vue&type=script&lang=ts"

import "./AudioDiv.vue?vue&type=style&index=0&id=16f0c45e&scoped=true&lang=scss"

import exportComponent from "/Users/daiwei/Documents/Dodoca/guinong/guinong-official-website/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f0c45e"]])

export default __exports__